export const GOOGLE_MAPS_KEY = 'AIzaSyAomZ2GbswSuVi7zS-NzIinO2C03NL1Hsc';



// WEBPACK FOOTER //
// ./src/js/secret.js